<template src="./index.html"></template>
<style lang="scss" scoped src="./index.scss"></style>
<script>
import { Search } from "vant";
import { mapState } from "vuex";
export default {
  components: { Search },
  name: "AddressBookSearchPage",
  data() {
    return {
      searchValue: "",
    };
  },
  computed: {
    ...mapState({
      SearchData: (state) => {
        return state.AddressBook.SearchData;
      },
    }),
  },
  mounted() {

    if(this.$route.params.active == 'focus' ){
      setTimeout(()=>{
        document.getElementById("searchInput").focus();
      },500)
      this.$store.commit('AddressBook/clear_SearchData',{})
    }
    if (this.$store.state.Public.AddressSearchData) {
      this.searchValue = this.$store.state.Public.AddressSearchData.value;
      if (this.$store.state.Public.AddressSearchData.data) {
        this.$store.commit("AddressBook/SET_DATA", {
          key: "SearchData",
          data: this.$store.state.Public.AddressSearchData.data,
        });
        this.$store.commit("Public/SET_DATA", {
          key: "AddressSearchData",
          data: {},
        });
      } else {
        this.$store.commit("AddressBook/SET_DATA", {
          key: "SearchData",
          data: [],
        });
      }
    }
  },
  methods: {
    // 监听页面滑动，页面滑动输入框失去焦点收起键盘
    touchstart() {
      document.getElementById("searchInput").blur()
    },
    onSearch() {
      let value = this.searchValue
      setTimeout(()=>{
        if( value == this.searchValue ){
          if (this.searchValue) {
            let params = { ww_id: this.searchValue };
            this.SearchDataList(params).then(res=>{
              if(this.searchValue==''){ // 有可能在请求时删除了搜索内容,导致请求后的数据被赋值
                this.$store.commit("AddressBook/SET_DATA", { key: "SearchData",data: []});
              }
            })
          } else {
            this.$store.commit("AddressBook/SET_DATA", {key: "SearchData",data: []});
          }
        }
      },1000)
    },
    noneSearch() {
      this.$router.go(-1);
    },
    async SearchDataList(params) {
      let res = await this.$store.dispatch("AddressBook/SearchData", params)
      return res
    },
    stroeChat(index) {
      // 跳转客户信息
      this.$router.push({
        path:'CustomerInfo', 
        query: {
          source:'2', 
          ww_nick: this.SearchData[index].row_data.ww_nick,
          buyer_openuid: this.SearchData[index].buyer_openuid,
          is_in_list: 1,
      }})
      let dataObj = { value: this.searchValue, data: this.SearchData };
      this.$store.commit("Public/SET_DATA", {
        key: "AddressSearchData",
        data: dataObj,
      });
    },
  },
};
</script>